<div class='dashboard-container' [attr.translate]="'no'">
  <app-notification-bar></app-notification-bar>
  <div class='main-wrapper'>
    <nav id='nav-sidebar' class='sidebar' [ngClass]='{"toggled": sidebarToggled}'>
      <div class='sidebar-box'>
        <div class="sidebar-logo">
          <img class="logo" src="/assets/jas-logo.png">
        </div>
      </div>
      <div class='sidebar-content'>
        <app-core-accordion-menu 
         [rootNavigation]="rootNavigation"></app-core-accordion-menu>
        <div [hidden]="environment.production" class="env-versions">
          <div class="d-flex flex-column">
            <div *ngIf="dependencies.length > 0">
              <div *ngFor="let dep of dependencies">
                <p>{{ dep.name }}: <span>{{ dep.version }}</span></p>
              </div>
            </div>
            <ng-container *ngIf="shipmentApiVersion">
              <ng-container *ngFor="let shipmentApiVer of shipmentApiVersion?.applicationInfo?.versions; let i = index">
                <p>Shipment Api {{shipmentApiVer.versionName}}
                  - <span>{{shipmentApiVer.version}}</span></p>
              </ng-container>
            </ng-container>
            <p>Core ver. <span>{{version}}</span></p>
          </div>
        </div>
      </div>
    </nav>
    <div class='main'>
      <nav class='navbar' [ngClass]='{"sidebar-toggled": !sidebarToggled}'>
        <div class='d-flex justify-content-between navbar-container'>
          <div class="d-flex align-items-center">
            <div class="togglex" id="togglex" (click)="spinButton()" (click)='toggleSidebar();'>
              <div class="iconx" id="iconx">
                <div class="top-icon"></div>
                <div class="middle-icon"></div>
                <div class="bottom-icon"></div>
              </div>
            </div>
            <ng-container *ngIf="getTabsForCurrentPath()">
              <h1 class="navbar-title">{{getTabsForCurrentPath().translateName | translate}}</h1>
              <nav mat-tab-nav-bar class="tabbed-nav" [tabPanel]="tabPanel">
                <ng-container *ngFor="let page of getTabsForCurrentPath().subNavigationItems; let i = index">
                  <a mat-tab-link routerLink="{{!page.disabled ? page.path : null}}" [active]="rla.isActive"
                     routerLinkActive *ngIf="moduleAccessService.currentUserHasAccessTo(page.module)"
                     [class.disabled]="page.disabled ? true: null" #rla="routerLinkActive"
                     [routerLinkActiveOptions]="{ exact: true }" [ngClass]="{'none': page.display === false}">
                    {{page.translateName | translate | uppercase}}
                  </a></ng-container>
              </nav>
              <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
            </ng-container>
          </div>

          <div class="d-flex align-items-center">
            <app-change-language></app-change-language>
            <!--BUTTONS TO DO-->
            <button mat-icon-button class='menu-button pr-3'
              *ngIf="false">
              <mat-icon [inline]='true' class='menu-icon ml-2'>inbox
              </mat-icon>
            </button>
            <button mat-icon-button class='menu-button pr-3'
              *ngIf="false">
              <mat-icon [inline]='true' class='menu-icon ml-2'>notifications
              </mat-icon>
            </button>
            <button mat-icon-button class='menu-button pr-3'
              *ngIf="false">
              <mat-icon [inline]='true' class='menu-icon ml-2'>account_circle
              </mat-icon>
            </button>
            <div class="box-icon">
              <button class="mx-2" mat-icon-button [matMenuTriggerFor]="menu"
                aria-label="Example icon-button with a menu">
                <div class="d-flex flex-column">
                  <mat-icon>person</mat-icon>
                </div>
              </button>
              <mat-menu #menu="matMenu">
                <div class="d-flex border-bottom p-3">
                  <span>{{oauthService.getIdentityClaims()?.name}}</span>
                </div>
                <button mat-menu-item (click)='redirectToChangePassword()'>
                  <mat-icon>key</mat-icon>
                  <span>{{'changePassword' | translate}}</span>
                </button>
                <button mat-menu-item (click)='openConfirmDialog()'>
                  <mat-icon>power_settings_new</mat-icon>
                  <span>{{'logout' | translate}}</span>
                </button>
              </mat-menu>
            </div>

          </div>
        </div>
      </nav>
      <div class='container-fluid app-content'>
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>